/**
 * LMS-adapter-registry.
 *
 * For å støtte en ny LMS:
 *   1. Lag en ny fil under lib/lms-adapters/ (kopier struktur fra eksisterende)
 *   2. Importer den her og legg til i LMS_ADAPTERS
 *   3. LmsMappingModal og LmsCoursesPage får automatisk støtte
 *   4. Backend-routes må eksistere (POST/PATCH/DELETE) for at submit skal virke
 */
import { moodleAdapter } from './moodle';
import { tutorlmsAdapter } from './tutorlms';
import { learndashAdapter } from './learndash';
import { xtramileAdapter } from './xtramile';
import type { LmsAdapter, LmsType } from './types';

export const LMS_ADAPTERS: Record<string, LmsAdapter> = {
  moodle: moodleAdapter,
  tutorlms: tutorlmsAdapter,
  learndash: learndashAdapter,
  xtramile: xtramileAdapter,
  // Fremtidige: mentorkit, schoolsoft, etc. — bare legg til adapter her.
};

export function getLmsAdapter(lmsType: LmsType): LmsAdapter | null {
  return LMS_ADAPTERS[lmsType] || null;
}

export type { LmsAdapter, LmsType, MappingFormData, MappingRow } from './types';
